export const TITLE = 'Thank you!';

export const SUB_TEXT = 'Great! Your identity has been verified.';

export const LOGGED_OUT_SUBTEXT = `${SUB_TEXT} If you want to sign in or join Ideal4Finance, please ask the account owner to add you as a team member`;

export const BUTTON = 'Back to onboarding';
